<template>
    <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease"
        role="banner" class="navbar w-nav">
        <div class="st-top-nav-container w-container">
            <a href="/" aria-current="page" class="st-main-logo w-nav-brand">
                <img src="/playlistability/assets/img/webflow/songtools-logo-vector-light.svg" loading="lazy" alt=""
                    class="logo-image">
            </a>
            <nav role="navigation" class="st-top-menu w-nav-menu">
                <a href="/playlisterclub" aria-current="page" class="st-topnav-link-plc w-nav-link">
                    PlaylisterClub
                </a>
                <a href="/songfly" class="st-topnav-link-sfyx w-nav-link">
                    SongFly
                </a>
                <a href="/songfolder" class="st-topnav-link-sf w-nav-link">
                    SongFolder
                </a>
                <a href="/songpage" class="st-topnav-link-spx w-nav-link">
                    SongPage
                </a>
                <a href="/songblog" class="st-topnav-link-sbx w-nav-link">
                    SongBlog
                </a>
                <a href="/#login" class="st-topnav-link-sf mini login w-nav-link">
                    Login
                </a>
                <a href="/#signup" class="st-topnav-link-sf mini signup w-nav-link">
                    Sign Up
                </a>
            </nav>
            <div class="menu-button w-nav-button">
                <div class="icon-2 w-icon-nav-menu"></div>
            </div>
        </div>
    </div>
  </template>
<script>
export default {
  name: 'Navbar',
};
</script>
<style lang="scss" scoped>
  @import '../assets/css/webflow/components.css';
  @import '../assets/css/webflow/normalize.css';
  @import '../assets/css/webflow/songtools.css';

  .navbar {
    padding: 0;
    min-height: unset;
    z-index: 9980;
  }

  .menu-button.w--open .w-icon-nav-menu:before {
    content: '\00d7';
  }
  </style>

  <style lang="scss">
  .w-nav-overlay {
    position: absolute;
    overflow: hidden;
    display: none;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
  }
  </style>
